import $ from 'jquery';

/**
 * @type class
 * @name FireComponent
 * @description
 *
 * Component class
 *
 * @param {String} key - a unique identifier for the component
 *
 **/
export class FireComponent {
  constructor(id) {
    // id is generated by FireComponentRecord
    this.id = id;
  }

  // grab component HTML element and assign to a variable,
  // this is now usable anywhere this Class is extended
  get $component() {
    return $(this.componentSelector);
  }

  // helper variable to get component selector
  get componentSelector() {
    return `[data-registered="${this.id}"]`;
  }

  // helper variable to check if the component exists
  get componentExists() {
    return this.$component.length !== 0;
  }

  // helper function to find specific child element of component
  findElement(element) {
    return this.$component.find(`[data-element=${element}]`);
  }
}
